<template>
  <div class="trans">
    <Header />
    <section class="login-page section-b-space mt90">
      <div class="container">
        <div class="theme-form d-flex flex-column justify-content-center align-items-center p-3">
          <h2 class="text-center register-title"> License Upload</h2>
          <h4>

<!--            uploaded nothing and nothing verified-->
            <template v-if="license_management.pending_dl === 0 && license_management.pending_dlb === 0 && license_management.pending_mc === 0
            && license_management.valid_18plus === 0 && license_management.valid_21plus === 0 && license_management.valid_dlb === 0 && license_management.valid_mc === 0">
              Please upload your driver license front and back and medical card if under the age of 21.
            </template>

<!--            uploaded dl dlb or both-->

            <template v-if="license_management.pending_dl === 0 && license_management.pending_dlb === 0 && license_management.pending_mc === 0
            && license_management.valid_18plus === 0 && license_management.valid_21plus === 0 && license_management.valid_dlb === 1 && license_management.valid_mc === 1">
              Valid medical card on file, please upload driver license front.
            </template>

            <template v-if="license_management.pending_dl === 0 && license_management.pending_dlb === 0 && license_management.pending_mc === 0
            && license_management.valid_18plus === 1 && license_management.valid_21plus === 1 && license_management.valid_dlb === 1 && license_management.valid_mc === 1">
              Valid 21+ driver license and medical card on file.
            </template>

            <template v-if="license_management.pending_dl === 1 && license_management.pending_dlb === 0 && license_management.pending_mc === 0
            && license_management.valid_18plus === 0 && license_management.valid_21plus === 0 && license_management.valid_dlb === 1 && license_management.valid_mc === 0">
             Please upload medical card if under the age of 21.
            </template>

            <template v-if="license_management.pending_dl === 1 && license_management.pending_dlb === 0 && license_management.pending_mc === 0
            && license_management.valid_18plus === 0 && license_management.valid_21plus === 0 && license_management.valid_dlb === 1 && license_management.valid_mc === 1">
              Driver license back and medical card valid, driver license front will be checked soon.
            </template>

            <template v-if="license_management.pending_dl === 1 && license_management.pending_dlb === 0 && license_management.pending_mc === 0
            && license_management.valid_18plus === 0 && license_management.valid_21plus === 0 && license_management.valid_dlb === 0 && license_management.valid_mc === 1">
              Please upload driver license back.
            </template>

            <template v-if="license_management.pending_dl === 0 && license_management.pending_dlb === 1 && license_management.pending_mc === 0
            && license_management.valid_18plus === 0 && license_management.valid_21plus === 0 && license_management.valid_dlb === 0 && license_management.valid_mc === 1">
              Please upload driver license front.
            </template>

            <template v-if="license_management.pending_dl === 0 && license_management.pending_dlb === 0 && license_management.pending_mc === 0
            && license_management.valid_18plus === 0 && license_management.valid_21plus === 0 && license_management.valid_dlb === 0 && license_management.valid_mc === 1">
              Please upload driver license front and back.
            </template>

            <template v-if="license_management.pending_dl === 1 && license_management.pending_dlb === 0 && license_management.pending_mc === 0
            && license_management.valid_18plus === 0 && license_management.valid_21plus === 0 && license_management.valid_dlb === 0 && license_management.valid_mc === 0">
              Please upload your driver license back and medical card if under the age of 21.
            </template>

            <template v-if="license_management.pending_dl === 0 && license_management.pending_dlb === 1 && license_management.pending_mc === 0
            && license_management.valid_18plus === 0 && license_management.valid_21plus === 0 && license_management.valid_dlb === 0 && license_management.valid_mc === 0">
              Please upload your driver license front and medical card if under the age of 21.
            </template>

            <template v-if="license_management.pending_dl === 0 && license_management.pending_dlb === 1 && license_management.pending_mc === 1
            && license_management.valid_18plus === 0 && license_management.valid_21plus === 0 && license_management.valid_dlb === 0">
              Please upload your driver license front.
            </template>

            <template v-if="license_management.pending_dl === 1 && license_management.pending_dlb === 1 && license_management.pending_mc === 0
            && license_management.valid_18plus === 0 && license_management.valid_21plus === 0 && license_management.valid_dlb === 0 && license_management.valid_mc === 0">
              Please upload your medical card if under the age of 21.
            </template>

            <template v-if="license_management.pending_dl === 0 && license_management.pending_dlb === 0 && license_management.pending_mc === 1
            && license_management.valid_18plus === 0 && license_management.valid_21plus === 0 && license_management.valid_dlb === 0 && license_management.valid_mc === 0">
              Please upload your driver license front and back.
            </template>

            <template v-if="license_management.pending_dl === 1 && license_management.pending_dlb === 0 && license_management.pending_mc === 1
            && license_management.valid_18plus === 0 && license_management.valid_21plus === 0 && license_management.valid_dlb === 0 && license_management.valid_mc === 0">
              Please upload your driver license back.
            </template>

            <template v-if="license_management.pending_dl === 1 && license_management.pending_dlb === 1 && license_management.pending_mc === 1
            && license_management.valid_18plus === 0 && license_management.valid_21plus === 0 && license_management.valid_dlb === 0 && license_management.valid_mc === 0">
              Thank you for uploading all licenses.
            </template>

<!--            // verified some -->

            <template v-if="license_management.pending_dlb === 1 && license_management.valid_18plus === 1 && license_management.valid_21plus === 1 && license_management.valid_mc === 0">
              Valid 21+ driver license on file.
            </template>

            <template v-if="license_management.valid_18plus === 1 && license_management.valid_21plus === 1 && license_management.valid_dlb === 1 && license_management.valid_mc === 0">
              Valid 21+ driver license on file.
            </template>

            <template v-if="license_management.pending_dlb === 1 && license_management.valid_18plus === 1 && license_management.valid_21plus === 1 && license_management.valid_mc === 1">
              Valid 21+ driver license and medical card on file.
            </template>

            <template v-if="license_management.pending_dlb === 1 && license_management.pending_dl === 1 && license_management.valid_mc === 1">
              Valid Medical card on file. We check your driver license soon.
            </template>

            <template v-if="license_management.valid_dlb === 1 && license_management.pending_dl === 1 && license_management.pending_mc === 1">
              Valid driver license back on file. We check the other licenses soon.
            </template>


<!--            Confirmed 18+ but under 21-->
            <template v-if="license_management.valid_18plus === 1 && license_management.valid_21plus === 0">

              <template v-if="license_management.valid_dlb === 1 && license_management.pending_mc === 0 && license_management.valid_mc === 0">
                Valid 18+ driver license on file. Please upload the medical card.
              </template>

              <template v-if="license_management.pending_dlb === 0 && license_management.valid_dlb === 0 && license_management.pending_mc === 0 && license_management.valid_mc === 0">
                Valid 18+ driver license on file. Please upload the medical card and driver license back.
              </template>

              <template v-if="license_management.pending_dlb === 1 && license_management.valid_dlb === 0 && license_management.pending_mc === 0 && license_management.valid_mc === 0">
                Valid 18+ driver license on file. Please upload the medical card.
              </template>

              <template v-if="license_management.pending_dlb === 0 && license_management.valid_dlb === 0 && license_management.pending_mc === 1 && license_management.valid_mc === 0">
                Valid 18+ driver license on file. Please upload the driver license back.
              </template>

              <template v-if="license_management.valid_dlb === 1 && license_management.pending_mc === 1">
                Valid 18+ driver license on file. We check your medical card soon.
              </template>

              <template v-if="license_management.pending_dlb === 1 && license_management.pending_mc === 1">
                Valid 18+ driver license on file. We check your other licenses soon.
              </template>

              <template v-if="license_management.valid_dlb === 1 && license_management.valid_mc === 1">
                Valid 18+ driver license and medical card on file.
              </template>

              <template v-if="license_management.pending_dlb === 1 && license_management.valid_mc === 1">
                Valid 18+ driver license and medical card on file.
              </template>

              <template v-if="license_management.pending_dlb === 0 && license_management.valid_dlb === 0 && license_management.valid_mc === 1">
                Valid 18+ driver license and medical card on file. Please upload driver license back.
              </template>

            </template>


          </h4>

          <div v-if="isUploading" class="upload-state">
            Uploading ...
          </div>

          <template v-if="show_dl_upload_button === 1">
            <button class="button" @click="proxyClick('DL')" :disabled="isUploading">Upload Driver License Front</button>
          </template>

          <template v-if="show_dlb_upload_button === 1">
            <button class="button" @click="proxyClick('DLB')" :disabled="isUploading">Upload Driver License Back</button>
          </template>

          <img v-if="imageURL" class="image" :src="imageURL">
          <template v-if="show_mc_upload_button === 1">
            <button class="button" @click="proxyClick('MC')" :disabled="isUploading">Upload Medical Card (optional if 21+)</button>
          </template>

          <div class="form-group d-flex justify-content-center">
            <input
                type="submit"
                class="btn btn-register mt-5"
                value="Continue"
                @click="openShopPage()"
                :disabled="isUploading"
            >
          </div>
          <Pagination :number="5" />
          <input
              v-show="false"
              ref="input"
              type="file"
              accept="image/*"
              capture="environment"
              @change="showPreviewAndPostToEndpoint"
          >
        </div>
      </div>
    </section>
    <Footer />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Header from "@/components/header";
import Footer from "@/components/footer";
import Pagination from '../../components/widgets/dot-pagination'

export default {
  name: 'CaptureImage',
  components: {
    Header,
    Footer,
    Pagination
  },
  data() {
    return {
      imageURL: null,
      isUploading: false,
      uploadState: '',
      dl_mc_button: null,
      show_dl_upload_button: 0,
      show_dlb_upload_button: 0,
      show_mc_upload_button: 0,
    };
  },
  computed: {
    ...mapGetters({
      license_management: 'auth/getLicenseManagement',
      signup_survey: 'cart/signup_survey',
    }),
  },
  watch: {
    getAccessToken: async function() {
      this.refreshData();
    },
    license_management: async function() {

      this.show_dl_upload_button = 0;

      if(this.license_management.valid_18plus === 1  || this.license_management.pending_dl === 1 || this.license_management.valid_21plus === 1) {
        this.show_dl_upload_button = 0;
      }
      if(this.license_management.ask_to_upload_dl_again === 1  || this.license_management.ask_upload_dl === 1) {
        this.show_dl_upload_button = 1;
      }

      if(this.license_management.valid_dlb === 1  || this.license_management.pending_dlb === 1) {
        this.show_dlb_upload_button = 0;
      }
      if(this.license_management.ask_to_upload_dl_again === 1  || this.license_management.ask_upload_dlb === 1) {
        this.show_dlb_upload_button = 1;
      }

      this.show_mc_upload_button = 1;

      if(this.license_management.valid_mc === 1 || this.license_management.pending_mc === 1) {
        this.show_mc_upload_button = 0;
      }
      if(this.license_management.ask_to_upload_dl_again === 1) {
        this.show_mc_upload_button = 1;
      }


    },
  },
  created() {
    this.startAutoUpdateTimer();
  },
  mounted() {
    this.refreshData();
    this.$store.dispatch('auth/setSigninLog',{type: 'signup_upload_page_opened', 'signinusername': ''});
  },
  beforeDestroy () {
    clearInterval(this.updateTimer);
  },
  methods: {
    startAutoUpdateTimer: function () {
      this.updateTimer = setInterval(function () {
        this.refreshData();
      }.bind(this), 5000);
    },
    openShopPage() {
      this.signedup = localStorage.getItem('signedup');
      localStorage.setItem('signedup', '0');
      if(this.signup_survey.active === 1 && this.signedup === '1') { // show only after signup, not for upload later.
        this.$router.push({name: 'survey'})
      }
      else {
        this.$router.push({name: 'shop'})
      }
    },
    refreshData() {
      this.$store.dispatch('auth/getDLMCData');
    },
    proxyClick(license_type) {
      this.dl_mc_button = license_type;
      this.$refs.input.click();
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);

        // conversion successful
        reader.onload = () => resolve(reader.result);

        // conversion failed
        reader.onerror = (err) => reject(err);
      });
    },
    postToEndpoint(base64EncodedString) {

      let long = 0;
      let lat  = 0;
      let firstname = '';
      let lastname = '';
      let phototype = this.dl_mc_button;

      this.$store.dispatch('auth/uploadDocument',{image: base64EncodedString, long: long, lat: lat, firstname: firstname, lastname: lastname, phototype: phototype });

      // todo: set vuex store vars to track while uploading and then show results based on JSON OK
      this.uploadState = 'Uploading ...';
      this.isUploading = true;
      this.dl_mc_button = null;
    },
    hideUploadState(duration) {
      // wait duration seconds and clear upload state
      setTimeout(() => {
        this.isUploading = false;
      }, duration * 1000);
    },
    showPreviewAndPostToEndpoint(e) {
      // get image file
      const [file] = e.target.files;

      // show some useful info, if no image
      if (!file) {
        // console.error('You did not select any image!');
        return;
      }

      // release memory occupied by previous image file, if any
      if (this.imageURL) {
        URL.revokeObjectURL(this.imageURL);
      }

      // preview image
      this.imageURL = URL.createObjectURL(file);

      // convert image to base64 string
      this.getBase64(file)
          // post base64 encoded string to endpoint
          .then(this.postToEndpoint)
          // show some useful info, success
          .then((res) => {
            // console.log('Upload successful!');
            this.uploadState = `Status: ${res.status}`;
            // wait duration seconds and clear upload state
            this.hideUploadState(5);
          })
          // show some useful info, if any error
          .catch((err) => {
            // console.error('Error: ', err);
            this.uploadState = `Error: ${err.message}`;
            // wait duration seconds and clear upload state
            this.hideUploadState(5);
          });
    },
  },
};
</script>

<style scoped>
.button {
  width: 200px;
  margin-top: 30px;
  margin-bottom: 30px;
  padding: 10px;
  font-weight: bold;
  color: #ffd100 ;
  background-color: #2774ae;
  border: none;
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
}

.button:disabled {
  background-color: lightslategrey;
  color: #333333;
  cursor: default;
}

.upload-state {
  padding: 10px;
  font-size: 20px;
  font-weight: bold;
  color: salmon;
}

.image {
  max-width: 300px;
  max-height: 200px;
}
</style>
